/**
 * Opti-Behavior 批量事件收集器 V2.0
 * 优化生产环境性能，1分钟批量发送，支持滚动深度、外链点击追踪
 * 适配后端API: /api/Behavior/pageview, /api/Behavior/batch, /api/Behavior/unload
 */

(function() {
  'use strict';
  
  // 检查是否已经初始化
  if (window.OptibehaviorBatchTracker) {
    console.warn('[BatchTracker] 批量追踪器已经初始化');
    return;
  }
  
  // 等待DOM就绪
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    console.log('[BatchTracker] 初始化批量追踪器 V2.0');
    
    // 检查配置
    if (typeof window.opti_behavior_heatmap === 'undefined') {
      console.error('[BatchTracker] 配置不存在，请在window.opti_behavior_heatmap中设置配置');
      return;
    }
    
    const config = window.opti_behavior_heatmap;
    
    // 验证必要配置
    if (!config.server_base) {
      console.error('[BatchTracker] 缺少 server_base 配置');
      return;
    }
    
    // 设置默认配置
    config.pageview_endpoint = config.pageview_endpoint || '/api/Behavior/pageview';
    config.batch_endpoint = config.batch_endpoint || '/api/Behavior/batch';
    config.unload_endpoint = config.unload_endpoint || '/api/Behavior/unload';
    config.batch_interval = config.batch_interval || 60000; // 1分钟
    config.reports = Array.isArray(config.reports) ? config.reports : 
                    (config.reports ? config.reports.split(',') : ['click_pc', 'scroll_pc', 'outbound_pc']);
    config._mode = config._mode || 'reporter';
    
    // 只初始化 reporter 模式
    if (config._mode !== 'reporter') {
      console.log('[BatchTracker] 非 reporter 模式:', config._mode);
      return;
    }
    
    // 检查是否启用了当前设备类型的追踪
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const devicePrefix = isMobile ? 'mobile' : 'pc';
    const requiredEvents = [`click_${devicePrefix}`, `scroll_${devicePrefix}`, `outbound_${devicePrefix}`];
    
    const hasRequiredEvents = requiredEvents.some(event => config.reports.includes(event));
    if (!hasRequiredEvents) {
      console.log(`[BatchTracker] 当前设备类型(${devicePrefix})未启用追踪`);
      return;
    }
    
    // 初始化批量追踪器
    window.OptibehaviorBatchTracker = new BatchTracker(config);
    window.OptibehaviorBatchTracker.start();
    
    console.log('[BatchTracker] 批量追踪器已启动，使用1分钟批量发送');
  }
  
  /**
   * 批量追踪器类
   */
  function BatchTracker(config) {
    this.config = config;
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.batchTimer = null;
    this.sessionStartTime = Date.now();
    this.maxScrollDepth = 0;
    this.sessionId = null;
    this.visitorId = null;
    this.lastActivityTime = Date.now();
    this.scrollThrottleTimer = null;
    this.unloadHandlerAttached = false;
    this.batchSizeLimit = 100; // 批次大小限制
    this.pageviewSent = false;
    
    // 初始化批次存储
    this.batch = {
      clicks: [],
      scrolls: [],
      outbound: [],
      startTime: Date.now(),
      scrollDepth: 0
    };
    
    // 设备信息检测
    this.deviceInfo = this.getDeviceInfo();
    
    console.log('[BatchTracker] 设备信息:', this.deviceInfo);
  }
  
  /**
   * 获取设备信息
   */
  BatchTracker.prototype.getDeviceInfo = function() {
    const userAgent = navigator.userAgent;
    
    // 检测浏览器
    let browser = 'Unknown';
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) browser = 'Chrome';
    else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) browser = 'Safari';
    else if (userAgent.includes('Firefox')) browser = 'Firefox';
    else if (userAgent.includes('Edg')) browser = 'Edge';
    else if (userAgent.includes('Opera') || userAgent.includes('OPR')) browser = 'Opera';
    else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) browser = 'Internet Explorer';
    
    // 检测操作系统
    let os = 'Unknown';
    if (userAgent.includes('Windows')) os = 'Windows';
    else if (userAgent.includes('Mac OS') || userAgent.includes('macOS')) os = 'macOS';
    else if (userAgent.includes('Linux') && !userAgent.includes('Android')) os = 'Linux';
    else if (userAgent.includes('Android')) os = 'Android';
    else if (userAgent.includes('iOS') || userAgent.includes('iPhone') || userAgent.includes('iPad')) os = 'iOS';
    
    // 检测设备类型
    let deviceType = 'Desktop';
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /Tablet|iPad|Android(?!.*Mobile)/i.test(userAgent);
    
    if (isMobile) deviceType = 'Mobile';
    if (isTablet) deviceType = 'Tablet';
    
    return {
      userAgent: userAgent,
      browser: browser,
      os: os,
      deviceType: deviceType,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isMobile: isMobile
    };
  };
  
  /**
   * 获取Cookie值
   */
  BatchTracker.prototype.getCookie = function(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  };
  
  /**
   * 生成nonce值
   */
  BatchTracker.prototype.generateNonce = function() {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    return btoa(`${timestamp}:${random}`).substring(0, 32);
  };
  
  /**
   * 开始追踪
   */
  BatchTracker.prototype.start = function() {
    console.log('[BatchTracker] 开始数据收集');
    
    // 1. 生成会话和访客ID
    this.generateSessionIds();
    
    // 2. 立即发送页面浏览事件
    if (!this.pageviewSent) {
      this.sendPageView();
    }
    
    // 3. 设置事件监听器
    this.setupEventListeners();
    
    // 4. 启动批量定时器
    this.startBatchTimer();
    
    // 5. 设置页面卸载处理
    this.setupUnloadHandler();
    
    console.log('[BatchTracker] 数据收集已开始，批量间隔:', this.config.batch_interval + 'ms');
  };
  
  /**
   * 设置事件监听器
   */
  BatchTracker.prototype.setupEventListeners = function() {
    const self = this;
    
    // 点击事件
    document.addEventListener('click', function(e) {
      self.handleClick(e);
    }, { capture: true, passive: true });
    
    // 滚动事件（节流处理）
    window.addEventListener('scroll', function() {
      self.handleScroll();
    }, { passive: true });
    
    // 键盘事件（保持会话活跃）
    document.addEventListener('keydown', function() {
      self.updateActivity();
    });
    
    // 鼠标移动事件（保持会话活跃）
    document.addEventListener('mousemove', function() {
      self.updateActivity();
    });
    
    console.log('[BatchTracker] 事件监听器已设置');
  };
  
  /**
   * 更新活动时间
   */
  BatchTracker.prototype.updateActivity = function() {
    this.lastActivityTime = Date.now();
  };
  
  /**
   * 处理点击事件
   */
  BatchTracker.prototype.handleClick = function(event) {
    // 更新活动时间
    this.updateActivity();
    
    // 排除一些不需要追踪的元素
    if (this.shouldIgnoreClick(event.target)) {
      return;
    }
    
    // 获取点击坐标
    const x = event.pageX || (event.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft));
    const y = event.pageY || (event.clientY + (document.documentElement.scrollTop || document.body.scrollTop));
    
    // 获取页面尺寸
    const width = Math.max(
      document.documentElement.scrollWidth,
      document.body.scrollWidth,
      document.documentElement.clientWidth
    );
    const height = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight,
      document.documentElement.clientHeight
    );
    
    // 获取元素信息
    const elementInfo = this.getElementInfo(event.target);
    
    // 创建点击事件数据（匹配ClickEvent模型）
    const clickEvent = {
      type: 'click',
      timestamp: Date.now(),
      x: Math.floor(x),
      y: Math.floor(y),
      width: Math.floor(width),
      height: Math.floor(height),
      device: this.isMobile ? 'mobile' : 'pc',
      element: elementInfo,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
    
    // 添加到批次
    this.batch.clicks.push(clickEvent);
    
    // 检查批次大小，如果太大则提前发送
    const totalEvents = this.batch.clicks.length + this.batch.scrolls.length + this.batch.outbound.length;
    if (totalEvents >= this.batchSizeLimit) {
      console.log(`[BatchTracker] 批次大小达到限制(${totalEvents})，提前发送批次`);
      this.sendBatch();
    }
    
    // 调试日志（限制频率）
    if (this.batch.clicks.length % 10 === 0) {
      console.log(`[BatchTracker] 已收集 ${this.batch.clicks.length} 次点击`);
    }
  };
  
  /**
   * 检查是否为外链点击
   */
  BatchTracker.prototype.handleOutboundClick = function(event) {
    // 查找链接元素
    let target = event.target;
    let link = null;
    
    while (target && target !== document) {
      if (target.tagName === 'A' && target.href) {
        link = target;
        break;
      }
      target = target.parentElement;
    }
    
    if (!link) return;
    
    // 检查是否为外链
    const targetUrl = link.href;
    const currentOrigin = window.location.origin;
    
    if (targetUrl.indexOf(currentOrigin) === 0) {
      return; // 内部链接，不记录
    }
    
    // 获取点击坐标
    const x = event.pageX || (event.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft));
    const y = event.pageY || (event.clientY + (document.documentElement.scrollTop || document.body.scrollTop));
    
    // 获取元素信息
    const elementInfo = this.getElementInfo(link);
    
    // 创建外链事件（匹配OutboundClickEvent模型）
    const outboundEvent = {
      type: 'outbound',
      timestamp: Date.now(),
      targetUrl: targetUrl,
      x: Math.floor(x),
      y: Math.floor(y),
      element: elementInfo
    };
    
    // 添加到批次
    this.batch.outbound.push(outboundEvent);
    
    console.log('[BatchTracker] 外链点击已记录:', targetUrl);
  };
  
  /**
   * 处理滚动事件（节流）
   */
  BatchTracker.prototype.handleScroll = function() {
    // 更新活动时间
    this.updateActivity();
    
    // 节流处理，每500ms更新一次滚动深度
    if (this.scrollThrottleTimer) {
      clearTimeout(this.scrollThrottleTimer);
    }
    
    this.scrollThrottleTimer = setTimeout(() => {
      this.updateScrollDepth();
    }, 500);
  };
  
  /**
   * 更新滚动深度
   */
  BatchTracker.prototype.updateScrollDepth = function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    
    const currentScrollDepth = Math.min(100, Math.round(
      ((scrollTop + windowHeight) / documentHeight) * 100
    ));
    
    // 只有滚动深度有明显变化时才记录
    if (Math.abs(currentScrollDepth - this.maxScrollDepth) >= 5) {
      this.maxScrollDepth = currentScrollDepth;
      
      // 记录滚动事件（匹配ScrollEvent模型）
      const scrollEvent = {
        type: 'scroll',
        timestamp: Date.now(),
        depth: currentScrollDepth,
        maxDepth: this.maxScrollDepth,
        scrollTop: scrollTop,
        viewportHeight: windowHeight
      };
      
      this.batch.scrolls.push(scrollEvent);
      this.batch.scrollDepth = this.maxScrollDepth;
      
      console.log('[BatchTracker] 滚动深度更新:', currentScrollDepth + '%');
    }
  };
  
  /**
   * 获取元素信息
   */
  BatchTracker.prototype.getElementInfo = function(element) {
    if (!element) return null;
    
    return {
      tag: element.tagName.toLowerCase(),
      id: element.id || null,
      // className: element.className || null,
      className:(element.className || '').toString().trim(),
      text: element.textContent ? element.textContent.trim().substring(0, 100) : null,
      selector: this.generateSelector(element)
    };
  };
  
  /**
   * 生成CSS选择器
   */
  BatchTracker.prototype.generateSelector = function(element) {
    if (!element) return '';
    
    const path = [];
    while (element && element.nodeType === Node.ELEMENT_NODE) {
      let selector = element.nodeName.toLowerCase();
      
      if (element.id) {
        selector += '#' + element.id;
        path.unshift(selector);
        break;
      } else {
        let sibling = element;
        let siblingCount = 1;
        while (sibling.previousElementSibling) {
          sibling = sibling.previousElementSibling;
          siblingCount++;
        }
        if (siblingCount > 1) {
          selector += ':nth-child(' + siblingCount + ')';
        }
      }
      
      path.unshift(selector);
      element = element.parentElement;
    }
    
    return path.join(' > ').substring(0, 200);
  };
  
  /**
   * 检查是否应该忽略点击
   */
  BatchTracker.prototype.shouldIgnoreClick = function(element) {
    if (!element) return true;
    
    // 忽略特定标签
    const ignoreTags = ['SCRIPT', 'STYLE', 'META', 'LINK', 'BR', 'HR'];
    if (ignoreTags.includes(element.tagName)) {
      return true;
    }
    
    // 忽略特定类名
    const ignoreClasses = ['opti-behavior-ignore', 'heatmap-ignore', 'batch-ignore'];
    if (element.className && typeof element.className === 'string') {
      for (const className of ignoreClasses) {
        if (element.className.includes(className)) {
          return true;
        }
      }
    }
    
    // 忽略特定属性
    if (element.hasAttribute && element.hasAttribute('data-batch-ignore')) {
      return true;
    }
    
    return false;
  };
  
  /**
   * 启动批次定时器
   */
  BatchTracker.prototype.startBatchTimer = function() {
    // 清除现有定时器
    if (this.batchTimer) {
      clearInterval(this.batchTimer);
    }
    
    // 设置批量定时器
    const interval = this.config.batch_interval || 60000;
    this.batchTimer = setInterval(() => {
      this.sendBatch();
    }, interval);
    
    console.log('[BatchTracker] 批次定时器已启动，间隔:', interval + 'ms');
  };
  
  /**
   * 发送批次数据
   */
  BatchTracker.prototype.sendBatch = function() {
    // 检查是否有数据需要发送
    const hasData = this.batch.clicks.length > 0 || 
                   this.batch.scrolls.length > 0 || 
                   this.batch.outbound.length > 0;
    
    if (!hasData) {
      console.log('[BatchTracker] 批次无数据，跳过发送');
      this.batch.startTime = Date.now(); // 重置开始时间
      return;
    }
    
    // 计算会话时长
    const sessionDuration = Math.round((Date.now() - this.batch.startTime) / 1000);
    
    // 准备批次数据（匹配BatchInput类）
    const batchData = {
      batchId: 'batch_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
      startTime: this.batch.startTime,
      endTime: Date.now(),
      sessionDuration: sessionDuration,
      scrollDepth: this.batch.scrollDepth,
      clicks: this.batch.clicks,
      scrolls: this.batch.scrolls,
      outbound: this.batch.outbound,
      pageInfo: {
        url: window.location.href,
        title: document.title,
        referrer: document.referrer || '',
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      }
    };
    
    console.log('[BatchTracker] 发送批次数据:', {
      批次ID: batchData.batchId,
      点击事件: batchData.clicks.length,
      滚动事件: batchData.scrolls.length,
      外链事件: batchData.outbound.length,
      会话时长: batchData.sessionDuration + '秒',
      滚动深度: batchData.scrollDepth + '%'
    });
    
    // 发送批次数据
    this.sendBatchToServer(batchData);
    
    // 重置批次
    this.resetBatch();
  };
  
  /**
   * 发送批次数据到服务器
   */
  BatchTracker.prototype.sendBatchToServer = function(batchData) {
    const url = this.config.server_base + this.config.batch_endpoint;
    
    // 准备表单数据（匹配后端API参数）
    const formData = new FormData();
    formData.append('batch_data', JSON.stringify(batchData));
    formData.append('session_id', this.sessionId || '');
    formData.append('visitor_id', this.visitorId || '');
    formData.append('url', window.location.href);
    formData.append('nonce', this.generateNonce()); // 添加nonce
    formData.append('app_id', this.config.app_id || 'default-app');
    
    console.log('[BatchTracker] 发送批次请求到:', url);
    
    // 发送请求
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      },
      keepalive: true // 确保在页面卸载时能发送
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('[BatchTracker] 批次发送成功:', data);
      
      // 如果服务器返回了新的会话ID，更新它
      if (data.sessionId) {
        this.sessionId = data.sessionId;
      }
    })
    .catch(error => {
      console.error('[BatchTracker] 批次发送失败:', error);
      
      // 失败时重试一次（延迟5秒）
      setTimeout(() => {
        console.log('[BatchTracker] 尝试重新发送批次数据');
        this.sendBatchToServer(batchData);
      }, 5000);
    });
  };
  
  /**
   * 重置批次
   */
  BatchTracker.prototype.resetBatch = function() {
    this.batch = {
      clicks: [],
      scrolls: [],
      outbound: [],
      startTime: Date.now(),
      scrollDepth: this.batch.scrollDepth // 保留滚动深度
    };
    
    console.log('[BatchTracker] 批次已重置');
  };
  
  /**
   * 生成会话和访客ID
   */
  BatchTracker.prototype.generateSessionIds = function() {
    // 会话ID（30分钟有效期）
    let sessionId = this.getCookie('optibehavior_sid') || this.getCookie('opti_behavior_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      const expires = new Date(Date.now() + 30 * 60 * 1000).toUTCString();
      document.cookie = `optibehavior_sid=${sessionId}; expires=${expires}; path=/; SameSite=Lax`;
    }
    
    // 访客ID（1年有效期，优先用localStorage）
    let visitorId = null;
    try {
      visitorId = localStorage.getItem('optibehavior_vid');
    } catch (e) {
      console.warn('[BatchTracker] localStorage不可用，使用cookie存储访客ID');
    }
    
    if (!visitorId) {
      visitorId = this.getCookie('optibehavior_vid') || this.getCookie('opti_behavior_visitor_id');
      if (!visitorId) {
        visitorId = 'vis_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        try {
          localStorage.setItem('optibehavior_vid', visitorId);
        } catch (e) {
          // 回退到cookie（1年有效期）
          const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `optibehavior_vid=${visitorId}; expires=${expires}; path=/; SameSite=Lax`;
        }
      }
    }
    
    this.sessionId = sessionId;
    this.visitorId = visitorId;
    
    console.log('[BatchTracker] ID生成完成:', {
      会话ID: sessionId.substring(0, 12) + '...',
      访客ID: visitorId.substring(0, 12) + '...'
    });
  };
  
  /**
   * 发送页面浏览事件
   */
  BatchTracker.prototype.sendPageView = function() {
    if (this.pageviewSent) return;
    
    const url = this.config.server_base + this.config.pageview_endpoint;
    
    // 准备页面浏览数据（匹配PageViewInput类）
    const pageViewData = {
      sessionId: this.sessionId,
      visitorId: this.visitorId,
      appId: this.config.app_id || 'default-app',
      url: window.location.href,
      title: document.title,
      referrer: document.referrer || '',
      timestamp: Date.now(),
      device: this.deviceInfo
    };
    
    console.log('[BatchTracker] 发送页面浏览事件:', {
      会话ID: pageViewData.sessionId.substring(0, 12) + '...',
      页面URL: pageViewData.url,
      设备: pageViewData.device.browser + ' on ' + pageViewData.device.os
    });
    
    // 发送请求
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(pageViewData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('[BatchTracker] 页面浏览事件发送成功:', data);
      this.pageviewSent = true;
    })
    .catch(error => {
      console.error('[BatchTracker] 页面浏览事件发送失败:', error);
    });
  };
  
  /**
   * 设置页面卸载处理器
   */
  BatchTracker.prototype.setupUnloadHandler = function() {
    if (this.unloadHandlerAttached) return;
    
    const self = this;
    
    // 页面卸载时发送剩余数据
    window.addEventListener('beforeunload', function() {
      self.sendBatchOnUnload();
    });
    
    // 页面隐藏时也尝试发送数据
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        self.sendBatchOnUnload();
      }
    });
    
    this.unloadHandlerAttached = true;
    console.log('[BatchTracker] 页面卸载处理器已设置');
  };
  
  /**
   * 页面卸载时发送批次
   */
  BatchTracker.prototype.sendBatchOnUnload = function() {
    // 检查是否有数据需要发送
    const hasData = this.batch.clicks.length > 0 || 
                   this.batch.scrolls.length > 0 || 
                   this.batch.outbound.length > 0;
    
    if (!hasData) return;
    
    console.log('[BatchTracker] 页面卸载，发送剩余数据');
    
    // 准备卸载数据（匹配UnloadInput类）
    const unloadData = {
      batchId: 'unload_batch_' + Date.now(),
      startTime: this.batch.startTime,
      endTime: Date.now(),
      sessionDuration: Math.round((Date.now() - this.batch.startTime) / 1000),
      scrollDepth: this.batch.scrollDepth,
      clicks: this.batch.clicks,
      scrolls: this.batch.scrolls,
      outbound: this.batch.outbound,
      remainingEvents: this.batch.clicks.length + this.batch.scrolls.length + this.batch.outbound.length,
      pageInfo: {
        url: window.location.href,
        title: document.title,
        referrer: document.referrer || '',
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      }
    };
    
    const url = this.config.server_base + this.config.unload_endpoint;
    
    // 使用 sendBeacon 发送（更可靠）
    if (navigator.sendBeacon) {
      const formData = new FormData();
      formData.append('unload_data', JSON.stringify(unloadData));
      formData.append('session_id', this.sessionId || '');
      formData.append('visitor_id', this.visitorId || '');
      formData.append('url', window.location.href);
      formData.append('nonce', this.generateNonce());
      formData.append('app_id', this.config.app_id || 'default-app');       
      
      const sent = navigator.sendBeacon(url, formData);
      console.log('[BatchTracker] sendBeacon 发送结果:', sent);
    } else {
      // 使用同步XMLHttpRequest（后备方案）
      try {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, false); // 同步请求
        
        const formData = new FormData();
        formData.append('unload_data', JSON.stringify(unloadData));
        formData.append('session_id', this.sessionId || '');
        formData.append('visitor_id', this.visitorId || '');
        formData.append('url', window.location.href);
        formData.append('nonce', this.generateNonce());
        
        xhr.send(formData);
        console.log('[BatchTracker] 同步请求发送完成');
      } catch (e) {
        console.error('[BatchTracker] 卸载数据发送失败:', e);
      }
    }
    
    // 重置批次（即使发送失败也重置，避免重复发送）
    this.resetBatch();
  };
  
  /**
   * 公共API：手动发送批次
   */
  BatchTracker.prototype.forceSendBatch = function() {
    console.log('[BatchTracker] 手动触发批次发送');
    this.sendBatch();
  };
  
  /**
   * 公共API：获取当前状态
   */
  BatchTracker.prototype.getStatus = function() {
    return {
      sessionId: this.sessionId,
      visitorId: this.visitorId,
      batchSize: this.batch.clicks.length + this.batch.scrolls.length + this.batch.outbound.length,
      clicks: this.batch.clicks.length,
      scrolls: this.batch.scrolls.length,
      outbound: this.batch.outbound.length,
      scrollDepth: this.batch.scrollDepth,
      lastActivity: new Date(this.lastActivityTime).toISOString(),
      sessionStart: new Date(this.sessionStartTime).toISOString()
    };
  };
  
  /**
   * 公共API：重置会话
   */
  BatchTracker.prototype.resetSession = function() {
    this.generateSessionIds();
    this.resetBatch();
    this.pageviewSent = false;
    this.sendPageView();
    console.log('[BatchTracker] 会话已重置');
  };
  
})();